module.exports = __webpack_public_path__ + "media/images/store_badges/google_play/google_play_zh-ae429d91491ed679e733a965b918729d.png";